import { css } from '@emotion/react';
import { THEME } from '@anytag/shared-constants';
import { ToastMessage } from './toast-message';

export const Body = ({ children, className }: React.ComponentProps<'div'>) => (
  <div css={styles.wrapper} className={className}>
    {children}
    <ToastMessage />
  </div>
);

const styles = {
  wrapper: css({
    flex: 1,
    overflow: 'hidden',
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor: THEME.background.colors.white
  })
};
